import React from 'react';
import {database} from './config';
import {getQueryVariable, numberWithCommas, renderDate} from "./util";
import {Redirect, Route, Switch} from "react-router-dom";
import {Card, Nav} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import {undoTransaction} from "./model/transaction";
import {UserInfo} from "./context";
import {toast} from "react-toastify";
import {withTranslation} from "react-i18next";

function materialsToString(materials) {
  let s = [];
  for (let name of Object.keys(materials)) {
    s.push(`${materials[name]} ${name}`)
  }
  return s.join(", ")
}

class TransactionLogPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: []
    }
  }

  componentDidMount() {
    let targetUserId = getQueryVariable(this.props.location.search, "target_user_id");
    let query;
    if (targetUserId) {
      query = database.collection("transactions").where("actorInfo.id", "==", targetUserId)
    } else {
      query = database.collection("transactions").orderBy("timestamp", "desc").limit(100)
    }

    query.onSnapshot((querySnapshot) => {
      let transactions = [];
      querySnapshot.forEach(function (doc) {
        let data = doc.data();
        data.id = doc.id;
        transactions.push(data);
      });
      this.setState({
        transactions: transactions,
      })
    })
  }

  undo(transaction) {
    const { t } = this.props;
    // eslint-disable-next-line no-restricted-globals
    if (confirm(t('pages:log.confirmUndo', { name: transaction.actorInfo.name, value: numberWithCommas(transaction.totalValue) }))) {
      undoTransaction(this.context, transaction.id).then(result => {
        toast.success(t('pages:log.messages.transactionUndone'))
      }).catch((error) => toast.error(error));
    }
  }

  renderActions(transaction) {
    const { t } = this.props;
    if (transaction.undone) {
      return <div><em>{t('pages:log.undoneBy', { name: transaction.undoneUserInfo.name })}</em></div>
    } else if (this.context.engineer || transaction.actorInfo.id === this.context.id) {
      return <div>
        <button className="btn btn-sm btn-danger" onClick={() => this.undo(transaction)}>{t('common:buttons.undo')}</button>
      </div>
    } else {
      return '-'
    }
  }

  renderTransactionRow = (transaction) => {
    return <tr key={transaction.id}>
      <td>{renderDate(transaction.timestamp)}</td>
      <td>{transaction.location}</td>
      <td>{transaction.actorInfo.name}</td>
      <td>{materialsToString(transaction.materials)}</td>
      <td>{numberWithCommas(transaction.totalValue)} ISK</td>
      <td>{this.renderActions(transaction)}</td>
    </tr>
  };

  render() {
    const { t } = this.props;
    return <table className={"table"}>
      <thead>
      <tr>
        <th>{t('common:labels.time')}</th>
        <th>{t('common:labels.location')}</th>
        <th>{t('common:labels.pilot')}</th>
        <th>{t('common:labels.materials')}</th>
        <th>{t('common:labels.value')}</th>
        <th>{t('common:labels.actions')}</th>
      </tr>
      </thead>
      <tbody>
      {this.state.transactions.map(this.renderTransactionRow)}
      </tbody>
    </table>
  }
}

TransactionLogPage.contextType = UserInfo;
const TranslatedTransactionLogPage = withTranslation(['pages', 'common'])(TransactionLogPage);

class PayoutLogPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payouts: []
    }
  }

  componentDidMount() {
    let targetUserId = getQueryVariable(this.props.location.search, "target_user_id");
    let actorUserId = getQueryVariable(this.props.location.search, "actor_user_id");
    let query;
    if (targetUserId) {
      query = database.collection("payouts").where("targetUserInfo.id", "==", targetUserId)
    } else if (actorUserId) {
      query = database.collection("payouts").where("actorUserInfo.id", "==", actorUserId)
    } else {
      query = database.collection("payouts").orderBy("timestamp", "desc").limit(100)
    }

    query.onSnapshot((querySnapshot) => {
      let transactions = [];
      querySnapshot.forEach(function (doc) {
        transactions.push(doc.data());
      });
      transactions.sort((a, b) => b.timestamp - a.timestamp);
      this.setState({
        payouts: transactions,
      })
    })
  }

  renderPayoutRow(payout) {
    return <tr>
      <td>{renderDate(payout.timestamp)}</td>
      <td>{payout.actorUserInfo.name}</td>
      <td>{payout.targetUserInfo.name}</td>
      <td>{payout.account || "unknown"}</td>
      <td>
        {payout.amountIsk !== 0 ? <div>
          {numberWithCommas(payout.amountIsk)} ISK
        </div> : null}
        {payout.amountPanda !== 0 ? <div>
          {numberWithCommas(payout.amountPanda)} 🐼
        </div> : null}
      </td>
    </tr>
  }

  render() {
    const { t } = this.props;
    return <table className={"table"}>
      <thead>
      <tr>
        <th>{t('common:labels.time')}</th>
        <th>{t('pages:log.payout.by')}</th>
        <th>{t('pages:log.payout.to')}</th>
        <th>{t('common:labels.type')}</th>
        <th>{t('common:labels.amount')}</th>
      </tr>
      </thead>
      <tbody>
      {this.state.payouts.map(this.renderPayoutRow)}
      </tbody>
    </table>
  }
}

const TranslatedPayoutLogPage = withTranslation(['pages', 'common'])(PayoutLogPage);

class LogPage extends React.Component {
  render() {
    const { t } = this.props;
    return <div className={"container log"}>
      <Card>
        <Card.Header>
          <Nav variant="tabs" defaultActiveKey="/home">

            <Nav.Item>
              <LinkContainer to="/log/transaction">
                <Nav.Link href="/log/transaction">{t('pages:log.tabs.transaction')}</Nav.Link>
              </LinkContainer>
            </Nav.Item>

            <Nav.Item>
              <LinkContainer to="/log/payout">

                <Nav.Link href="/log/payout">{t('pages:log.tabs.payout')}</Nav.Link>
              </LinkContainer>

            </Nav.Item>
          </Nav>
        </Card.Header>

        <Switch>
          <Route exact path="/log">
            <Redirect to="/log/transaction"/>
          </Route>
          <Route path="/log/transaction" component={TranslatedTransactionLogPage}>
          </Route>
          <Route path="/log/payout" component={TranslatedPayoutLogPage}/>
        </Switch>
      </Card>
    </div>
  }
}

export default withTranslation(['pages', 'common'])(LogPage);